import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { VmeCommonModule } from '../../vme-common.module';
import { VMEComponentsModule } from '../../vme-components.module';
import { VmeDirectivesModule } from '../../vme-directives.module';
import { VmePipesModule } from '../../vme-pipes.module';
import { ScoreCardsComponent } from './score-cards.component';

const routes: Routes = [
  { path: '', component: ScoreCardsComponent, data: { title: 'VME Rate Cards' } },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class ScoreCardsRoutingModule {}

@NgModule({
  imports: [
    ScoreCardsRoutingModule,
    VmeCommonModule,
    VmeDirectivesModule,
    VmePipesModule,
    VMEComponentsModule,
  ],
  declarations: [ScoreCardsComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class ScoreCardsModule {}
